module.exports = __webpack_public_path__ + "static/Diversity Dashboard-1176f330a51c0579dd6c8bf4bae0de89.jpg";